import {PublicFlowEnum} from '../constants/PublicFlowEnum';
import {useCancelSignUpFlowStore} from '../sign-up/store/useCancelSignUpFlowStore';
import {usePublicFlowStore} from '../store/usePublicFlowStepStore';

export function useResetPublicFlow() {
	const resetModalState = useCancelSignUpFlowStore(state => state.resetModalState);

	const resetSignUpStep = usePublicFlowStore(state => state.resetStep);

	const handleResetPublicFlow = () => {
		resetModalState();
		resetSignUpStep(PublicFlowEnum.FORGOT_PASSWORD);
		resetSignUpStep(PublicFlowEnum.SIGN_UP);
	};

	return {
		handleResetPublicFlow,
	};
}
